import { RestApiDataService } from '@/services/api/RestApiDataService'
import { VSwitch, VTextField, VTextarea } from 'vuetify/lib'
import RichTextField from '@/components/ui/crud/fields/RichTextField.vue'
import DateField from '@/components/ui/crud/fields/DateField.vue'

const BASE_ENTITY_URL = '/legal-info-pages'
const SLUG_RE = /^[a-z0-9\-_/]+$/

class LegalInfoPageDataService extends RestApiDataService {
  getCrudFields () {
    return [
      { key: 'title', label: 'Заголовок', component: VTextField, rules: ['required'] },
      { key: 'listTitle', label: 'Заголовок в списке', component: VTextField },
      {
        key: 'slug',
        label: 'Slug',
        component: VTextField,
        rules: [
          'required',
          (v) => (v && v.length <= 191) || 'Не более 191 символа',
          (v) => SLUG_RE.test(v || '') || 'Только a-z, 0-9, -, _, /',
        ],
      },
      { key: 'sortOrder', label: 'Индекс сортировки', component: VTextField, rules: ['number'], defaultValue: 100 },
      { key: 'isActive', label: 'Активна', component: VSwitch, defaultValue: true },
      { key: 'effectiveDate', label: 'Дата вступления в силу', component: DateField },
      { key: 'metaTitle', label: 'Meta title', component: VTextField },
      { key: 'metaDescription', label: 'Meta description', component: VTextarea },
      { key: 'metaKeywords', label: 'Meta keywords (через запятую)', component: VTextField },
      { key: 'content', label: 'Содержимое', component: RichTextField },
    ]
  }
}

export default new LegalInfoPageDataService(BASE_ENTITY_URL)
